import { createContext } from 'react'

export interface UserInfo {
  username: string
  userLocale: string
  identity?: string
}

export interface AppState {
  locale?: string
  returnTo?: string
  caseId?: string
  renewalId?: string
  opportunityId?: string
  customerId?: string
  policyLevel?: string
  draftPolicy?: string
  driverCase?: boolean
  submittedQuoteNumber?: string
}

export interface AuthContextType {
  isAuthenticated: boolean
  user: UserInfo | null
  isLoading: boolean
  getAccessTokenSilently: () => Promise<string>
  login: (appState: AppState) => Promise<void>
  logout: () => void
  passwordResetRedirect?: (azureLocale: AzureLocale) => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export interface AzureLocale {
  locale: string
  ui_locales?: string
}
